function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10.5L2 8l1.078-1.078c.886-.886 1.329-1.328 1.853-1.608a4 4 0 011.495-.453c.591-.058 1.205.065 2.433.31L10.5 5.5m8 8l.328 1.64c.246 1.229.37 1.843.311 2.434a4.002 4.002 0 01-.452 1.496c-.28.524-.723.967-1.609 1.852L16.001 22l-2.5-3.5M7 17l2-2m8.002-6a2 2 0 11-4 0 2 2 0 014 0zm.197-7h-.549c-.978 0-1.467 0-1.928.11a4 4 0 00-1.156.48c-.404.247-.75.593-1.441 1.285L7 9c-1.09 1.09-1.636 1.636-1.927 2.224a4 4 0 000 3.552c.291.588.836 1.133 1.927 2.224v0c1.09 1.09 1.636 1.636 2.224 1.927a4 4 0 003.552 0C13.364 18.636 13.91 18.09 15 17l5.125-5.126c.692-.691 1.037-1.037 1.285-1.44.22-.359.38-.749.479-1.157.11-.46.11-.95.11-1.928V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.31-1.311C19.718 2 18.878 2 17.198 2z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#2F384C"
  }, props), _ref);
};

export default SvgRocket;